import IconArrowBack from '@/components/icons/arrowBack.vue'
import IconBase from '@/components/IconBase.vue'
import IconPhone from '@/components/icons/mobilePhone.vue'
import IconForwardBack from '@/components/icons/arrowForward.vue'
import Globals from '@/assets/scripts/global-functions.js'
import Axios from "axios"
import { verify } from 'crypto';
import BackButton from '@/components/BackButton.vue'
import NextButton from '@/components/forms/ButtonNext.vue'
import DateOfBirth from '@/components/forms/DateOfBirth.vue'

export default {
    name: "HelloUser",
    components: {
        IconArrowBack,
        IconBase,
        IconForwardBack,
        IconPhone,
        BackButton,
        NextButton,
        DateOfBirth
    },
    data: () => ({
        wrong_birthday: "",
        first_name: "",
        email_address: "",
        phone_number: "",
        mobile_number: "",
        confirm_birth_day: "",
        confirm_birth_month: "",
        confirm_birth_year: "",
        db_birthdate: "",
        db_session: "",
        is_mobile: true,
        current_session_id: "",
        dialog_check_sessions: false,
        days_of_the_month: [],
        month_of_the_year: [
            { text:'January', value:'1' },
            { text:'February', value:'2' },
            { text:'March', value:'3' },
            { text:'April', value:'4' },
            { text:'May', value:'5' },
            { text:'June', value:'6' },
            { text:'July', value:'7' },
            { text:'August', value:'8' },
            { text:'September', value:'9' },
            { text:'October', value:'10' },
            { text:'November', value:'11' },
            { text:'December', value:'12' }
        ],
        years: [],
         dictionary: {
            custom: {
                email_address: {
                    required: () => 'Email address is required to proceed',
                    email: () => 'Invalid email'
                },
                phone_number: {
                    required: () => 'Phone number is required to proceed',
                    max: 'Cannot exceed more than 20 characters',
                    numeric: 'Phone number should only contains numerice characters',
                    regex: 'Please enter a valid Australian phone number'
                },
                mobile_number: {
                    required: () => 'Phone number is required to proceed',
                    max: 'Cannot exceed more than 11 characters',
                    numeric: 'Mobile number should only contains numerice characters',
                    regex: 'Please enter a valid Australian phone number'
                },
                confirm_birth_day: {
                    required: () => 'Birth day is required to proceed'
                },
                confirm_birth_month: {
                    required: () => 'Birth month is required to proceed'
                },
                confirm_birth_year: {
                    required: () => 'Birth year is required to proceed'
                }
            }
         },
         
    }),
    methods: { 
        UpdateProcess(_isvalid) {
            if(_isvalid) {
                const _dob = this.GetDateOfBirth();
                this.$parent.EducatorInsuranceProcess.Educators[0].email_address = this.email_address;
                this.$parent.EducatorInsuranceProcess.Educators[0].mobile_number = this.mobile_number;
                this.$parent.EducatorInsuranceProcess.Educators[0].phone_number = this.phone_number;
                
                this.$parent.EducatorInsuranceProcess.Educators[0].date_of_birth = _dob.year + "/" + _dob.month + "/" + _dob.day;
                this.$parent.EducatorInsuranceProcess.Educators[0].birth_day = _dob.day;
                this.$parent.EducatorInsuranceProcess.Educators[0].birth_month = _dob.month;
                this.$parent.EducatorInsuranceProcess.Educators[0].birth_year = _dob.year;
                

                this.$parent.EducatorNextStep(3,"PreviousPolicies");
            } else {
                console.error("There seems to be an error in your entries");
            }
            
        },
        Next() {
            /* this can be improved and simplified */
            const _dob = this.GetDateOfBirth();
            let _false_counter = 0;
            this.$validator.validate('email_address', this.email_address).then((result) => { 
                if(!result) { _false_counter++; }
                if(_dob.valid) {
                    if(this.is_mobile) {
                        this.$validator.validate('mobile_number', this.mobile_number).then((result) => { 
                            if(!result) { _false_counter++; }
                            if( _false_counter > 0 ) {
                                this.UpdateProcess(false);
                            } else {
                                this.UpdateProcess(true);
                            }
                        });
                    } else {
                        this.$validator.validate('phone_number', this.phone_number).then((result) => { 
                            if(!result) { _false_counter++; }
                            if(_false_counter > 0) {
                                this.UpdateProcess(false);
                            } else {
                                this.UpdateProcess(true);
                            }
                        });
                    }
                }
            });
        },
        CreateNumberRange(_start, _end) {
            let _data = [];
            for(var i = _start; i <= _end; i++) {
                if(i < 10) { _data.push("0" + i); } else { _data.push(i); }
            }
            return _data;
        },
        ValidateEmailAddress() {
            if(this.email_address !== "") {
                if(this.fields.email_address.valid) {
                    document.getElementById("email_address").classList.add("entry_valid")
                } else {
                    document.getElementById("email_address").classList.remove("entry_valid")
                }
            }
        },
        ValidateSessionData() {
            if(this.$parent.EducatorInsuranceProcess.Educators[0].email_address) {
                const _educator = this.$parent.EducatorInsuranceProcess.Educators[0];
                this.email_address = _educator.email_address;
                this.phone_number = _educator.phone_number;
                this.mobile_number = _educator.mobile_number;
                this.$refs.dob.SetDateOfBirth(_educator.birth_year, _educator.birth_month, _educator.birth_day);
                
                if(_educator.mobile_number != "") {
                    this.is_mobile = true;
                } else {
                    this.is_mobile = false;
                }
                this.$validator.validateAll(); /* this was added to add success state on fields and buttons */
            }
        },
        GetDateOfBirth() {
            return this.$refs.dob.GetDateOfBirth();
        },
        disableModal(){
            this.dialog_check_sessions = false;
            
        },
        Continue(_params){
            if(_params == "No"){
                this.NotContinue();
            }else{
                this.YesContinue();
            }
        },
        NotContinue(){
            this.disableModal();
            Globals.UpdateIsDeletedToTrue(this.db_session.id, "EducatorInsuranceProcess", this.Role);
            Globals.CleanStorage("EducatorInsuranceProcess");
            this.$parent.GoToPage('Welcome');
        },
        YesContinue(){
            var confirm_bdate = new Date(this.confirm_birth_year,this.confirm_birth_month.value,this.confirm_birth_day);
            var dbbirthdate = new Date(this.db_birthdate);

            var confirm_bdate_ = confirm_bdate.getFullYear() + '-' + confirm_bdate.getMonth() + '-' + confirm_bdate.getDate();
            var dbbirthdate_ = dbbirthdate.getFullYear() + '-' + (dbbirthdate.getMonth() + 1) + '-' + dbbirthdate.getDate();

            if(dbbirthdate_ == confirm_bdate_) {
                //if the same repopulate
                this.$parent.EducatorInsuranceProcess = JSON.parse(this.db_session.data);
                this.$parent.session_id = this.db_session.id;
                this.$parent.is_local_storage = true;
                this.$parent.SessionUpdate("EducatorInsuranceProcess");

                let dbDay = (dbbirthdate.getDate()).toString();

                if(dbDay.length == 1) { dbDay = '0' + dbDay; }

                this.$parent.EducatorInsuranceProcess.Educators[0].birth_day =  dbDay;
                this.$parent.EducatorInsuranceProcess.Educators[0].birth_month = (dbbirthdate.getMonth() + 1).toString();
                this.$parent.EducatorInsuranceProcess.Educators[0].birth_year = dbbirthdate.getFullYear();

                this.mobile_number = this.$parent.EducatorInsuranceProcess.Educators[0].mobile_number;
                this.ValidateSessionData()
                this.disableModal();
            }else{
                this.wrong_birthday = "Birthday does not match! Please try again."
                this.dialog_check_sessions = true;
            }  
        },
        CheckSessionByEmail(){
            this.$parent.EducatorInsuranceProcess.Educators[0].email_address = this.email_address;

            //axios
            let CheckSessionByEmail_ = Globals.CheckSessionByEmail("EducatorInsuranceProcess", this.$parent.EducatorInsuranceProcess, this.$parent.Role);
            
            //check response of axios 
            CheckSessionByEmail_.then(response => {
                var count = response.data.customizations.results.length;
                this.db_session = response.data.customizations.results[0];
                
                //if session exist
                if(count > 0 ){
                    //check session if not expired
                    let isSessionNotExpired = Globals.CheckSessionExpiry("EducatorInsuranceProcess", this.$parent.db_session.date_expiry, this.db_session.id);
               
                    if(isSessionNotExpired == "false"){
                        //session not yet expired
                        this.dialog_check_sessions = true;
                        this.db_birthdate = this.db_session.birthdate;
                        let today = new Date(); 
                        let today_date = today.getDate() + today.getMonth() + ' ' + today.getFullYear();
                        this.$parent.EducatorInsuranceProcess.date_modified = today_date;
                        Globals.UpdateExpiryDate(this.db_session.id, this.$parent.Role);
                    }
                }
            })
            .catch(response => { 
                console.error("CheckSessionByEmail", response);
            });
                    
        }

    },
    watch : {

    },
    computed: {
        AllFieldsValid: function() {
            let _isvalid = false;
            let fld = this.fields;            
            if(fld.email_address) {
                if(this.is_mobile) {
                    if(fld.mobile_number.valid) {
                        _isvalid = true
                    } else {
                        _isvalid = false;
                    }
                } else {
                    if(fld.phone_number.valid) {
                        _isvalid = true;
                    } else {
                        _isvalid = false;
                    }
                }
            }
            return _isvalid;
        },
        IsUnderaged: function() {
            let _isunderage = false;
            if((this.birth_year !== "") && (this.birth_month.value !== "") && (this.birth_day !== "")) {
                let _year = new Date().getUTCFullYear();
                let _yob = parseInt(this.birth_year);
                let _age = _year - _yob;
                
                if(_age < 19) {
                    _isunderage = true;
                }
            }
            return _isunderage; 
        }
    },
    mounted() {
        this.$validator.localize('en', this.dictionary) 
        this.$parent.CheckWindowPathName();
        this.ValidateSessionData();
        this.$parent.CurrentProcess = "EducatorInsuranceProcess";
    }
}